import { NouserComponent } from './nouser/nouser.component';
import { InstantPredictComponent } from './predict/instant-predict/instant-predict.component';
import { PredictUsingExcelComponent } from './predict/predict-using-excel/predict-using-excel.component';

import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { HomeComponent } from './home/home.component';
import { ConfigComponent } from './config/config.component';
import { ManageUserComponent } from './manage-user/manage-user.component';
import { PredictComponent } from './predict/predict.component';
import { TrainComponent } from './train/train.component';
import { LayoutComponent } from './layout/layout.component';

import { Step3newdataComponent } from './train/step3newdata/step3newdata.component';
import { Step3DoneComponent } from './train/step3-done/step3-done.component';
import { Step3Component } from './train/step3/step3.component';
import { Step2newdataComponent } from './train/step2newdata/step2newdata.component';
import { Step2Component } from './train/step2/step2.component';
import { UpdateComponent } from './home/update/update.component';
import { LoggedInGuard } from "./authentication/logged-in.guard";
import { TrainxlsComponent } from './train/trainwithxls/trainwithxls.component';
import { UnAuthorizedComponent } from './nouser/unauthorized/unauthorized.component';
import { TimeoutComponent } from './nouser/timeout/timeout.component';
import { NgModule } from '@angular/core';

const appRoutes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'Unauthorized', component: UnAuthorizedComponent },
  { path: 'timeout', component: TimeoutComponent },
  { path: 'logout', component: LogoutComponent },

  { path: 'login', component: LoginComponent },
  { path: 'No_user', component: NouserComponent, canActivate: [LoggedInGuard] },
  // { path: '', component: HomeComponent},
  { path: 'Dash', component: LayoutComponent, canActivate: [LoggedInGuard] },
  { path: 'Home', component: HomeComponent, canActivate: [LoggedInGuard] },
  { path: 'Train', component: TrainComponent, canActivate: [LoggedInGuard] },
  { path: 'Predict', component: PredictComponent, canActivate: [LoggedInGuard] },
  { path: 'ManageUser', component: ManageUserComponent, canActivate: [LoggedInGuard] },
  { path: 'Config', component: ConfigComponent, canActivate: [LoggedInGuard] },
  { path: 'Home/Update', component: UpdateComponent, canActivate: [LoggedInGuard] },
  { path: 'Train/Step2', component: Step2Component, canActivate: [LoggedInGuard] },
  { path: 'Train/Step2NewData', component: Step2newdataComponent, canActivate: [LoggedInGuard] },
  { path: 'Train/Step3', component: Step3Component, canActivate: [LoggedInGuard] },
  { path: 'Train/Step3Done', component: Step3DoneComponent, canActivate: [LoggedInGuard] },
  { path: 'Train/Step3NewData', component: Step3newdataComponent, canActivate: [LoggedInGuard] },
  { path: 'Predict/PredictUsingExcel', component: PredictUsingExcelComponent, canActivate: [LoggedInGuard] },
  { path: 'Predict/InstantPredict', component: InstantPredictComponent, canActivate: [LoggedInGuard] },
  { path: 'Train/trainwithxls', component: TrainxlsComponent, canActivate: [LoggedInGuard] },


  // otherwise redirect to home
  { path: '**', redirectTo: 'Home' }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { onSameUrlNavigation: 'reload', relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
